import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { type PlanRevisionRequest } from '../../../../models/PlanRevisionRequest'
import { Error } from '@mui/icons-material'
import { ResolveRevisionRequest } from '../../../../services/AnnualPlanService'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { Modal } from '../../../customComponents/Modal'

interface Props {
  readOnly: boolean
  revisionRequest?: PlanRevisionRequest
  onSave: () => void
}

export const RevisionRequestDisplay = (props: Props): JSX.Element => {
  const [isConfirming, setIsConfirming] = useState(false)

  const handleCheckClick = (): void => {
    setIsConfirming(true)
  }

  const confirmResolve = async (): Promise<void> => {
    await ResolveRevisionRequest(props.revisionRequest?.id ?? 0)
    setIsConfirming(false)
    toast.success(`Revision feedback for ${props.revisionRequest?.taskName ?? ''} was resolved`)
    props.onSave()
  }

  if (props.revisionRequest == null || props.revisionRequest.resolved) {
    return <></>
  }

  return <Box sx={{ borderRadius: '16px', border: '1px solid var(--red-700)' }}>
    <Box
      sx={{
        bgcolor: 'var(--red-700)',
        borderTopLeftRadius: '14px',
        borderTopRightRadius: '14px',
        display: 'flex',
        alignItems: 'center',
        px: '17px',
        py: '5px'
      }}
    >
      <Error sx={{ color: 'white', width: '20px', height: '20px' }} />

      <Typography variant='h5' sx={{ color: 'white', ml: '.25em' }}>
        Annual Plan Needs Revision
      </Typography>
    </Box>

    <Box sx={{ p: '16px', bgcolor: 'white', borderBottomLeftRadius: '14px', borderBottomRightRadius: '14px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='body1'>
          {props.revisionRequest.revisionText}
        </Typography>

        <FormControlLabel
          sx={{ alignItems: 'start', textWrap: 'nowrap' }}
          control={<Checkbox checked={false} disabled={props.readOnly} onClick={handleCheckClick} sx={{ pt: 0 }} data-testid='revisionsCompleteCheckbox' />}
          label='Revisions Complete'
        />
      </Box>
    </Box>

    {isConfirming &&
      <Modal
        open={true}
        title='Confirm Revisions Complete'
        confirmButtonText='Yes, Continue'
        cancelButtonText='No, I am not ready'
        onClose={() => { setIsConfirming(false) }}
        onConfirm={confirmResolve}
        bodyContent='This will lock this area for any additional changes. Are you sure you want to continue?'
      />
    }
  </Box>
}
